<template>
    <fragment>
        <div class="map-component">
            <button v-if="!readOnly" href="#" class="btn btn-outline-primary btn-xs  btn-block" v-on:click="geocodeAddress"><i class="fas fa-map-marker-alt"></i> Ricerca indirizzo</button>
            <gmap-map ref="map" :center="center" :key="gmapkey"
                      :zoom="18"
                      style="width:100%;  height: 400px;">
                <gmap-marker v-for="m in markers" :draggable="!readOnly"
                             :position="m.position" @dragend="updateCoordinate"></gmap-marker>
            </gmap-map>
            <div class="text-muted text-right">   <font-awesome-icon icon="map-marked-alt" class="text-info"></font-awesome-icon> <strong>Lat:</strong>{{value.latitude}}  <strong>Lng:</strong>{{value.longitude}} </div>

        </div>
        
        </fragment>

       

</template>
<script>




export default {
        name: 'gmap',
       
        props: {
            readOnly: {
                type: Boolean,
                required: false,
                default:() => false
            },
            
            value: {
                type: Object,
                required: false,
                
            },
            addressProperties: {
                type: Array,
                required: false,
                default:()=>['address','zipcode']
            }
        },
        data() {
            return {
                center: { lat: 0, lng: 0 },
                markers :[]
            }
        },
        computed: {
            gmapkey() {
                return window.SETTINGS["GMAPKEY"];

            },
            //markers() {
            //    this.internalMarkers = [];
            //    this.internalMarkers.push({
            //        position: { lat: 0, lng: 0 }
            //    });
            //    if (this.value.Latitude) {
            //        this.internalMarkers = [];
            //        this.internalMarkers.push({ position: { lat: this.value.Latitude, lng: this.value.Longitude } });
            //        this.center = { lat: this.value.Latitude, lng: this.value.Longitude };
            //    }

                
            //    return this.internalMarkers;
            //},
        },
        components: {
           
        },
       
        methods: {
            geocodeAddress() {
                console.log('geocode');
                var geocoder = new google.maps.Geocoder();
                var me = this;
                
                    
                var address = [];
                for (var i = 0; i < this.addressProperties.length; i++) {
                    address.push(this.value[this.addressProperties[i]] || '');
                }
                console.log(address,this.addressProperties,this.value);
                geocoder.geocode({ 'address': address.join(" ") }, function (results, status) {
                    if (status === 'OK') {
                        var location = { lat: results[0].geometry.location.lat(), lng: results[0].geometry.location.lng() };
                        me.center = location;
                       me.markers =[{ position:location }]
                     
                        me.value.latitude = location.lat;
                        me.value.longitude = location.lng;
                    } else {
                       // showMessage("Impossibile trovare " + address, 'warning', 'Mappa');
                    }
                })
            },
            updateCoordinate(location) {
                for (var i = 0; i < this.markers.length; i++) {
                    this.value.latitude = location.latLng.lat();
                    this.value.longitude = location.latLng.lng();
                    var l = { lat: location.latLng.lat(), lng: location.latLng.lng() };
                    this.center = l;

                }
            }
         
            
        },

        mounted() {
            var me = this;
            if (this.value.latitude) {
                me.markers = [];
                me.markers.push({ position: { lat: this.value.latitude, lng: this.value.longitude } });
                me.center = { lat: this.value.latitude, lng: this.value.longitude };
            }
        }
}
</script>

<style lang="css">
  .nav-link {
    cursor:pointer;
  }
</style>
